import React from 'react';
import { useRef } from 'react';
import { useOnClickOutside } from '../Helpers/useOnClickOutside';

function UserActionsMenuList(props) {
	// console.log('UserActionsMenuList - Props:', props);
	const ref = useRef();
	useOnClickOutside(ref, () => props.hideMenuList());

	return (
		<div className="UserActionsMenuList">
			{props.isMenuListVisible ? (
				<div ref={ref} style={props.style}>
					{props.data.map((d) => (
						<div key={d.type} onClick={d.action} className="action-menu-item">
							<div>{d.displayName}</div>
						</div>
					))}
				</div>
			) : null}
		</div>
	);
}

export default UserActionsMenuList;
